import React, { useState } from 'react';
import './Cotton.css';
import { shallowEqual, useSelector } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';
import Practice from '../../../Unit3/Module14/Practice';
import PracticeSituation from '../../Practice/PracticeSituation';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function CottonPractice(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [cottons, setCottons] = useState(false);
  const [cotton1, setCotton1] = useState(true);
  const [cotton2, setCotton2] = useState(false);
  const [cotton3, setCotton3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [practice, setPractice] = useState('');
  const [displayReview, setDisplayReview] = useState(false);
  const [openPractice, setOpenPractice] = useState(false);
  const [cottonScene, setCottonScene] = useState(true);
  const [displayLearnVideo, setDisplayLearnVideo] = useState(true);
  const [learnVideo, setlearnVideo] = useState(props.video1);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const cotton1Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandy1.svg');
  const cotton2Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandy2.svg');
  const cotton3Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandy3.svg');
  const stick1Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandyStick1.svg');
  const stick2Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandyStick2.svg');
  const stick3Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandyStick3.svg');
  const optionThink = {
    img: generateImageUrl('images/Module19Images/practice/Think about what you want to say.png'),
    title: 'Think about what you want to say or do',
    audioPrompt: 'appfiles/self_advocacy/option_think_about_what_to_say.mp3',
  };

  const optionBelieve = {
    img: generateImageUrl('images/Module19Images/practice/belieive in yourself.png'),
    title: 'Believe in yourself',
    audioPrompt: 'appfiles/self_advocacy/option_believe_in_self.mp3',
  };

  const optionAchieve = {
    img: generateImageUrl('images/Module19Images/practice/achieve it.png'),
    title: 'Achieve it',
    audioPrompt: 'appfiles/self_advocacy/option_achieve_it.mp3',
  };
  const standUpForSelf = {
      prompt: 'When you need to speak up or stand up for yourself, first',
      audioPrompt: 'appfiles/self_advocacy/scenario_stand_up_for_yourself.mp3',
      correctMatch: optionThink,
      incorrectMatches: [optionBelieve, optionAchieve],
      animal: generateImageUrl('images/Module1Images/Crab.svg'),
  };
  const singJingleTo = {
      prompt: 'After you think about what you want to say or do, think positive thoughts and sing the joyful jingle to',
      audioPrompt: 'appfiles/self_advocacy/scenario_sing_jingle_to.mp3',
      correctMatch: optionBelieve,
      incorrectMatches: [optionThink, optionAchieve],
      animal: generateImageUrl('images/Module1Images/Crab.svg'),
  };
  const afterThinkAndBelieve = {
      prompt: 'After you think about what you want to say or do and believe in yourself, the next thing you do is',
      audioPrompt: 'appfiles/self_advocacy/scenario_after_think_and_believe.mp3',
      correctMatch: optionAchieve,
      incorrectMatches: [optionThink, optionBelieve],
      animal: generateImageUrl('images/Module1Images/Crab.svg'),
  };
  const titles = ['Step 1', 'Step 2', 'Step 3'];
  const options = [standUpForSelf, singJingleTo, afterThinkAndBelieve];
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));

  // CSS code for the back button

 
  const displayPractice = (num) => {
    setPractice(
      <PracticeSituation
        options={[options[num - 1]]}
        title={titles[num - 1]}
        setDisplayPractice={setOpenPractice}
        background={props.background}
        stepComplete={''}
        module={props.module}
        next={() => {
          if (num === 1) {
            setEffect1('');
            setEffect2('bounceIcons');
            setCotton2(true);
            sleep(700).then(() => {
              bounceSound.play()
            });
          } else if (num === 2) {
            setEffect2('');
            setEffect3('bounceIcons');
            setCotton3(true);
            sleep(700).then(() => {
              bounceSound.play()
            });
          } else if (num === 3) {
            setDisplayReview(true);
            setCottonScene(false);
            setOpenPractice(false);
          }
        }}
      />
    );
    setOpenPractice(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      {openPractice && practice}
      {cottonScene && !openPractice && (
        <div
          className='cottonScene'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {displayLearnVideo && (
            <CloudfrontVideoFormat
              source={learnVideo}
              back={'unit4'}
              background={props.background}
              close={props.setDisplayPractice}
              ended={() => {
                setDisplayLearnVideo(false);
                setCottons(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              }}
            />
          )}
          {cottons && (
            <div className='monkey_cotton'>
              <div className='cottons'>
                {cotton1 && (
                  <div
                    className='cotton_stick1'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        displayPractice(1);
                      });
                    }}
                  >
                    <img
                      alt=''
                      className='cotton1'
                      id={effect1}
                      src={cotton1Img}
                    />
                    <br />
                    <img alt='' className='stick1' src={stick1Img} />
                  </div>
                )}
                {cotton2 && (
                  <div
                    className='cotton_stick2'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        displayPractice(2);
                      });
                    }}
                  >
                    <img
                      alt=''
                      className='cotton2'
                      id={effect2}
                      src={cotton2Img}
                    />
                    <br />
                    <img alt='' className='stick2' src={stick2Img} />
                  </div>
                )}
                {cotton3 && (
                  <div
                    className='cotton_stick3'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        touchSound.play()
                        sleep(500).then(() => {
                          displayPractice(3);
                        });
                      });
                    }}
                  >
                    <img
                      alt=''
                      className='cotton3'
                      id={effect3}
                      src={cotton3Img}
                    />
                    <br />
                    <img alt='' className='stick3' src={stick3Img} />
                  </div>
                )}
              </div>
              {<img alt='' className='animateMonkey' src={generateImageUrl('images/Module19Images/monkey_holding.png')} />}
            </div>
          )}
        </div>
      )}
      {displayReview && (
        <Practice
          reviewVideo={props.video2}
          setDisplayPractice={props.setDisplayPractice}
          background={props.background}
          stepComplete={'MODULE19_SET_stepCompleted'}
          module={props.module}
          unit4={true}
        />
      )}
    </>
  );
}
